import { Box } from '@mui/material';

export const a11yProps = (index) => ({
  id: `tab-${index}`,
  'aria-controls': `tabpanel-${index}`,
});

const TabPanel = ({ children, value, index, sx = {}, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3, ...sx }}>
          {children}
        </Box>
      )}
    </div>
  );
};

export default TabPanel;
